import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { constantUrl } from "src/app/Shared/constantUrl";

declare var $: any;
class MyUploadAdapter {
  loader: any;
  constructor(loader) {
    // The file loader instance to use during the upload.
    this.loader = loader;
  }

  // Starts the upload process.
  upload() {
    return this.loader.file.then(
      (
        file //{
      ) =>
        new Promise((resolve, reject) => {
          let reader = new FileReader();
          let _data: any = {};
          _data.DocName = file.name;
          reader.readAsDataURL(file);
          let $this = this;
          reader.onload = function () {
            _data.DocData = reader.result.toString().split(";base64,").pop();
            return $this.uploadFile(resolve, reject, _data);
          };
        })
    );
  }
  uploadFile(resolve, reject, data) {
    $.ajax({
      url: `${constantUrl.apiEndpointUploadDoc}/api/UploadDoc/UploadTemplateDoc`,
      type: "POST",
      data: JSON.stringify(data),
      contentType: "application/json;",
      success: (result, status, xhr) => {
        return resolve({
          default: constantUrl.SenctionTemplateImageUrl + result,
        });
      },
      error: (error, status, xhr) => {
        return reject(`Couldn't upload file: ${data.DocName}.`);
      },
    });
  }
}
function MyCustomUploadAdapterPlugin(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    // Configure the URL to the upload script in your back-end here!
    return new MyUploadAdapter(loader);
  };
}
@Component({
  selector: "app-nocletter-template",
  templateUrl: "./nocletter-template.component.html",
  styleUrls: ["./nocletter-template.component.scss"],
})
export class NocletterTemplateComponent implements OnInit {
  currentUser: any;
  private _encdec;
  showSpinner: boolean = false;

  templateData: any = "";
  loading: boolean = false;
  productDropdown: any[] = [];
  ProductId: any = "";
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private formBuilder: FormBuilder,
    private dataSharingService: DataSharingService,
    private _MasterService: MasterService,
    private snackBar: MatSnackBar
  ) {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }
  htmlContent1 = "";
  htmlContent2 = "";

  config2: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    minHeight: "500px",
    maxHeight: "500px",
    placeholder: "Enter text here...",
    translate: "no",
    sanitize: true,
    toolbarPosition: "top",
    defaultFontName: "Comic Sans MS",
    defaultFontSize: "5",
    defaultParagraphSeparator: "p",
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };
  form: FormGroup;

  ngOnInit() {
    this.form = this.formBuilder.group({
      signature: ["", Validators.required],
    });
    this.dataSharingService.LOSHeaderTitle.next("NOC Letter Template");

    this.getProductDropdown();
  }
  getProductDropdown() {
    this.showSpinner = true;
    this._MasterService.GetProductForDropdown().subscribe((result: any) => {
      this.productDropdown = JSON.parse(JSON.stringify(result));

      this.showSpinner = false;
    });
  }
  getNOCLetter() {
    this._MasterService
      .Get_NOCLetter({ ProductId: this.ProductId })
      .subscribe((res: any) => {
        this.templateData = res[0].TemplateData;
      });
  }
  onSavetemplate() {
    this._MasterService
      .Save_NOCLetter({
        ProductId: this.ProductId,
        TemplateData: this.templateData,
      })
      .subscribe((res: any) => {
        this.loading = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      });
  }

  onChange(event) {
    console.log("changed");
  }

  onBlur(event) {
    console.log("blur " + event);
  }

  onChange2(event) {
    console.warn(this.form.value);
  }
}
